import axios from './axios'

function authService(endpoint) {

    function csrf() {
        return axios.get(`csrf-cookie`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function login(data) {
        return axios.post(`${endpoint}/login`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    /** Belépés a Globalixból kapott, egyszer használható tokennel (Globalix → XMED SSO). */
    function loginWithGlobalixToken(token) {
        return axios.post(`public/sso/globalix`, {token}).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    /** Belépés a Globalixba ágyazott keretbe (#273): a válasz a menüpont (`target`) és az intézmény. */
    function loginWithGlobalixEmbedToken(token) {
        return axios.post(`public/sso/globalix/embed`, {token}).then(response => {
            return response.data;
        });
    }

    /** Kétfaktoros belépés: a függő belépés állapota (csatornák, várakozás, szövegek). */
    function twoFactorChallenge() {
        return axios.get(`two-factor/challenge`).then(response => response.data);
    }

    /** Kód kérése a választott csatornán (`mail` | `sms`). */
    function twoFactorSend(channel) {
        return axios.post(`two-factor/send`, {channel}).then(response => response.data);
    }

    /** A kód ellenőrzése; jó kódnál a válasz ugyanaz, mint a jelszavas belépésé. */
    function twoFactorVerify(code) {
        return axios.post(`two-factor/verify`, {code}).then(response => response.data);
    }

    function logout() {
        return axios.post(`${endpoint}/logout`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function register(data) {
        return axios.post(`${endpoint}/register`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function forgotPassword(data) {
        return axios.post(`${endpoint}/forgot-password`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function resetPassword(data) {
        return axios.post(`${endpoint}/reset-password`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function permissions() {
        return axios.get(`${endpoint}/permissions`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        csrf,
        login,
        twoFactorChallenge,
        twoFactorSend,
        twoFactorVerify,
        loginWithGlobalixToken,
        loginWithGlobalixEmbedToken,
        logout,
        register,
        forgotPassword,
        resetPassword,
        permissions
    }
}

export default authService
